import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

// es/fr temporarily hidden (translations pending review). Restricting this to
// "en" means any cached Spanish/French preference — or a Spanish/French
// browser locale — falls back to English instead of rendering a half-hidden
// language. Re-add "es", "fr" here (and in Sidebar's languageOptions) to
// bring them back; the locale JSON files are still in place.
const SUPPORTED_LANGUAGES = ["en"];

if (!i18n.isInitialized) {
  void i18n
    .use(HttpApi)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      fallbackLng: "en",
      supportedLngs: SUPPORTED_LANGUAGES,
      defaultNS: "common",
      ns: ["common"],
      load: "languageOnly",
      interpolation: {
        escapeValue: false,
      },
      backend: {
        loadPath: "/locales/{{lng}}/{{ns}}.json",
      },
      detection: {
        order: ["localStorage", "navigator", "htmlTag"],
        caches: ["localStorage"],
      },
      react: {
        useSuspense: false,
      },
      returnNull: false,
    });
}

export default i18n;
